{
  class CookieCloserButton extends HTMLButtonElement {
    constructor() {
      super();
    }

    // Simplify the text block
    superMinifyTextBlock(text) {
      return text.replace(/[^A-Za-z0-9]/g, '').toLowerCase();
    }

    // Hash the simplified text
    simpleHash(text) {
      let hash = 0;
      if (text.length === 0) return hash;
      for (let i = 0; i < text.length; i++) {
        const char = text.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash; // Convert to 32-bit integer
      }
      return hash;
    }

    // Display the notification if no cookie is found
    displayNotificationsIfCookieNotFound() {
      const notification = this.closest(this.getAttribute('closest-content-selector'))
      if(notification){
        const text = this.superMinifyTextBlock(notification.innerText);
        const hash = this.simpleHash(text);
        const cookie = window.coolHelperFunctions.getTemporaryLocalStorage(`notification${hash}`)
        if (!cookie) {
          notification.style.display = 'block';
        }
      }
    }

    // Set cookie and close notification on button click
    setCookieAndCloseNotification(e) {
      const notification = this.closest(this.getAttribute('closest-content-selector'))
      const notificationHeight = notification.offsetHeight;
      const text = this.superMinifyTextBlock(notification.innerText);
      const hash = this.simpleHash(text);

      window.coolHelperFunctions.setTemporaryLocalStorage(`notification${hash}`, 1, 365, 'days')
      notification.style.display = 'none';

      // Resize sticky header placeholder
      const placeholder = document.querySelector('.main-header--placeholder');
      if (placeholder) {
        const originalHeight = placeholder.offsetHeight;
        placeholder.style.height = `${originalHeight - notificationHeight}px`;
      }
    }

    connectedCallback() {
      // admin preview hack fix because gutenberg doesn't like custom elements
      if(this.hasAttribute('className')){
        this.classList = this.getAttribute('className')
        this.removeAttribute('className')
      }

      this.displayNotificationsIfCookieNotFound()
      this.addEventListener('click', e => this.setCookieAndCloseNotification(e))
    }
  }

  // Define custom element extending button
  customElements.define('cookie-closer', CookieCloserButton, { extends: 'button' });
}